<template>
  <div class="user-info">
    <img alt="" class="back-ground" src="@/assets/images/img_bg@3x.png">
    <div class="user-compile">
      <div style="display: flex;align-items: center;justify-content: space-between">
        <dr-maintenance :info-list="aroundList" />
        <van-button class="add-equipment-buttin add-equipment-buttin-num" type="primary" @click="$router.push('/changePhone')">编辑</van-button>
      </div>
      <div class="compile-info">
        <van-field
          v-for="(item , index) of userInfo"
          :key="index"
          ref="keyword"
          v-model="item.content"
          :readonly="!onlyCompile || item.key === 'city'||item.key === 'province'"
          label="文本"
        >
          <template v-slot:label>
            <split-label :label="item.title" />
          </template>
          <template v-slot:right-icon>
            <van-button v-if="item.key === 'city'||item.key === 'province'" class="add-equipment-buttin add-equipment-buttin-num" type="primary" @click="handleGetRegion(index)">编辑</van-button>
          </template>
        </van-field>
      </div>
    </div>
    <div class="add-equipment">
      <van-button class="add-equipment-buttin" icon="add-o" type="primary" @click="$router.push('/equipment')">添加设备
      </van-button>
      <van-button class="add-equipment-buttin" icon="add-o" type="primary" @click="handleCompileick">
        <!--        {{ onlyCompile ? '保存' : '编辑' }}-->
        保存
      </van-button>
    </div>
    <div v-for="(item , index) of userDeviceCodeList" :key="index" class="equipment-info">
      <van-field
        ref="keyword"
        v-model="item.deviceCode"
        readonly
        label="文本"
      >
        <template v-slot:label>
          <split-label label="出厂编号" />
        </template>
        <template #right-icon>
          <img alt="" class="compile-icon" src="@/assets/images/icon_delete@2x.png" :pointer-events="onlyCompile ? false: 'none'" @click="handleDeleteInfo(item.id,index)">
        </template>
      </van-field>
      <van-field
        ref="keyword"
        v-model="item.remark"
        label="文本"
      >
        <template v-slot:label>
          <split-label label="备注" />
        </template>
      </van-field>
      <van-field
        ref="keyword"
        v-model="item.model"
        readonly
        class="none-margin"
        label="文本"
      >
        <template v-slot:label>
          <split-label label="型号" />
        </template>
      </van-field>
    </div>
    <van-overlay :show="loading" class="overlay-loading">
      <van-loading size="40px" />
    </van-overlay>
    <van-popup v-model="showCity" class="equipment-popup" position="bottom" round>
      <van-picker
        :columns="columnsCity"
        show-toolbar
        title="城市"
        @cancel="showCity = false"
        @confirm="onConfirmCity"
      />
    </van-popup>
    <van-popup v-model="show" class="equipment-popup" position="bottom" round>
      <van-picker
        :columns="columns"
        show-toolbar
        title="省份"
        @cancel="show = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import DrMaintenance from '@/components/Maintenance'
import { Dialog, Toast } from 'vant'
import { equipmentList } from '@/utils/titleList'

export default {
  name: 'Userinfo',
  components: { DrMaintenance },
  data() {
    return {
      isCity: true, // 城市选择器
      cityId: '', // 城市Id
      columns: [], // 省份选择器内容
      show: false, // 省份选择器
      regionCode: 0, // 省份Id
      columnsCity: [], // 城市选择器内容
      showCity: false, // 城市选择器
      compileIdx: '', // 编辑
      documentHeight: document.documentElement.clientHeight, // 默认屏幕高度
      isOriginHei: true, // 页面高度控制按钮显示
      loading: false, // loading
      onlyCompile: true, // 编辑状态
      userDeviceCodeList: [], // 设备列表
      userInfo: [], // 用户信息列表
      equipmentList, // 设备列表信息
      aroundList: [], // 用户信息
      areaListCity: [], // 省市变量
      provinceId: '' // 省份Id
    }
  },
  watch: {
    show(newValue, oldValue) {
      if (!newValue) {
        this.areaList.forEach(item => {
          // eslint-disable-next-line eqeqeq
          if (item.name == this.userInfo[2].content) {
            this.regionCode = item.id
          }
        })
        this.provinceId = this.regionCode
        this.cityId = ''
        this.handleGetCity('city')
      }
    }
  },
  mounted() {
    this.handleGetCity()
    this.getInfo()
    // window.onresize监听页面高度的变化
    window.onresize = () => {
      return (() => {
        this.isOriginHei = !(this.documentHeight > document.documentElement.clientHeight)
      })()
    }
  },
  methods: {
    // 更改省份城市
    onConfirm(val, type) {
      this.userInfo[2].content = val + ''
      this.userInfo[3].content = ''

      this.show = false

      this.areaList.forEach(item => {
        // eslint-disable-next-line eqeqeq

        if (item.name === this.userInfo[2].content) {
          this.regionCode = item.id
        }
      })
      this.provinceId = this.regionCode
      this.cityId = ''
      this.handleGetCity('city')
      if (!type) {
        this.userInfo[3].content = ''
      }
    },
    /*
  选择地区（弹出层）
*/
    handleGetRegion(index) {
      if (index === 2) {
        this.isCity = false
        this.show = true
        return
      }
      if (index === 3 && this.isCity) {
        this.areaList.forEach(item => {
          // eslint-disable-next-line eqeqeq
          if (item.name == this.userInfo[2].content) {
            this.regionCode = item.id
          }
        })
        this.handleGetCity('city')
      }
      this.showCity = true
    },
    /*
      省市区管理
     */
    handleGetCity(goal) {
      this.$api('PROVINCE_CITY_SEARCH_H5', {
        personId: this.regionCode
      }, true).then((res) => {
        // eslint-disable-next-line eqeqeq
        if (goal == 'city') {
          this.areaListCity = res.result.map(item => {
            const { id, name } = item
            return {
              id,
              name
            }
          })
          this.columnsCity = []
          this.areaListCity.forEach(item => {
            this.columnsCity.push(item.name)
          })
          return
        }
        this.areaList = res.result.map(item => {
          const { id, name } = item
          return {
            id,
            name
          }
        })
        this.columns = []
        this.areaList.forEach(item => {
          this.columns.push(item.name)
        })
      })
    },
    // 更改省份城市
    onConfirmCity(val) {
      this.userInfo[3].content = val + ''
      this.regionCode = 0
      this.handleGetCity()
      this.areaListCity.forEach(item => {
        // eslint-disable-next-line eqeqeq
        if (item.name == this.userInfo[3].content) {
          this.cityId = item.id
        }
      })
      this.showCity = false
    },
    /*
      编辑设备
    */
    handleCompileick() {
      if (this.onlyCompile === false) {
        this.onlyCompile = true
        return
      }
      // this.onlyCompile = false
      this.handleSaveClick()
    },
    /*
    * 删除设备信息
    * */
    handleDeleteInfo(id, index) {
      if (this.userDeviceCodeList.length === 1) {
        this.$toast('至少保留一个设备')
        return
      }
      Dialog.confirm({
        title: '确认删除',
        message: '请确认是否删除所绑定设备？'
      })
        .then(() => {
          this.$api('USER_DEVICE_DEL_H5', {
            id: id
          }).then((res) => {
            // this.deleteInfo(index)
            if (res.code === 200) {
              this.getInfo()
            } else {
              this.$toast(res.msg)
            }
          })
        })
    },
    /*
      保存设备信息
    */
    handleSaveClick() {
      this.userDeviceInfoList = this.userDeviceCodeList.map(item => {
        const { remark, model, deviceCode, id } = item
        return {
          id,
          remark,
          model,
          deviceCode
        }
      })

      if (this.userInfo[0].content.length < 2) {
        Toast('所属医院的长度不能小于2位')
        return
      }

      if (this.userInfo[1].content.length < 2) {
        Toast('所属地址的长度不能小于2位')
        return
      }

      if (this.userInfo[3].content.length <= 0) {
        Toast('请选择城市')
        return
      }

      if (this.userInfo[4].content.length < 2 || this.userInfo[4].content.length > 64) {
        Toast('所属科室的长度不能小于2位大于32位')
        return
      }

      if (this.userInfo[5].content.length < 2 || this.userInfo[5].content.length > 64) {
        Toast('职位的长度不能小于2位大于32位')
        return
      }
      if (this.userInfo[6].content.length > 32 || this.userInfo[6].content.length < 2) {
        Toast('姓名的长度不能小于2位大于32位')
        return
      }
      this.$api('USER_DEVICE_EDIT_H5', {
        deviceCodeList: this.userDeviceInfoList
      }, true).then(() => {
        this.alterInfo()
      })
    },
    /*
      删除设备
    */
    deleteInfo(index) {
      if (this.onlyCompile === false) return
      this.userDeviceCodeList.splice(index, 1)
    },
    // 编辑个人信息
    alterInfo() {
      this.$api('USER_EDIT_H5', {
        hospitalName: this.userInfo[0].content, // 医院名称
        hospitalAddress: this.userInfo[1].content, // 医院地址
        provinceId: this.provinceId, // 医院地址
        cityId: this.cityId, // 医院地址
        hospitalDepartment: this.userInfo[4].content, // 科室
        hospitalPosition: this.userInfo[5].content, // 职位
        name: this.userInfo[6].content // 姓名
      }, true).then((res) => {
        if (res.code !== 200) {
          Toast(res.msg)
          return
        }
        Toast(this.$t('modifySuccessfully'))
        this.$set(this.userInfo, this.compileIdx, { ...this.userInfo[this.compileIdx], isCanEdit: false })
      })
    },
    /*
      用户信息是否编辑状态
    */
    handleonlyCompile(idx) {
      this.compileIdx = idx
      Toast('开始编辑')
      this.$set(this.userInfo, idx, { ...this.userInfo[idx], isCanEdit: true })
    },
    /*
      获取用户信息
    */
    getInfo() {
      this.$api('USER_INFO_H5', {}, true).then((res) => {
        this.result = res.result
        this.cityId = this.result.cityId
        this.provinceId = this.result.provinceId
        this.aroundList = [
          { title: '联系电话', content: this.result.phonenum }
        ]
        this.userDeviceCodeList = res.result.userDeviceCodeList
        this.userInfo = [
          { title: this.$t('hospital'), content: this.result.hospitalName, key: 'hospitalName', isCanEdit: false },
          { title: this.$t('address'), content: this.result.hospitalAddress, key: 'hospitalAddress', isCanEdit: false },
          { title: '省份', content: this.result.province, key: 'province', isCanEdit: false },
          { title: '城市', content: this.result.city, key: 'city', isCanEdit: false },
          {
            title: this.$t('department'),
            content: this.result.hospitalDepartment,
            key: 'hospitalDepartment',
            isCanEdit: false
          },
          {
            title: this.$t('position'),
            content: this.result.hospitalPosition,
            key: 'hospitalPosition',
            isCanEdit: false
          },
          { title: this.$t('name'), content: this.result.name, key: 'name', isCanEdit: false }
        ]
      })
    }
    /*
      退出登录
     */
    // handleLogoutClick() {
    //   // TODO
    //   logout()
    // }
  }
}
</script>

<style lang="scss" scoped>
.add-equipment-buttin {
  margin-left: 15px;
  padding: 8.5px;
  border-radius: 5px;
  margin-top: 11.5px;
  width: 90px;
  height: 26.5px;
  background-color: #CEE1F7;
  border: none;
  color: #005BAC;
  font-size: 12px;
}
.add-equipment-buttin-num {
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  width: 45px;
}
.overlay-loading {
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;

  ::v-deep .van-cell::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 0.42667rem;
    bottom: 0;
    left: 0.42667rem;
    border-bottom: none;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
  }

  ::v-deep .label-split {
    display: flex;
    justify-content: space-between;
    width: 70px;
    font-size: 15px;
  }

  ::v-deep .dr__maintenance .base-info .info-item .info_value {
    flex: 1;
    margin-left: 0.65333rem;
    font-size: 0.37333rem;
    word-break: break-all;
    line-height: 0.36rem;
  }

  ::v-deep .dr__maintenance .base-info .info-item {
    .info_label {
      width: 92px;
      line-height: 0.36rem;
      font-size: 15px;

      .label span {
        font-size: 15px;
      }
    }

    .info_value {
      margin-left: 25.5px;
    }
  }

  ::v-deep .van-cell {
    font-size: 15px;
    display: flex;
    align-items: center;
    border-bottom: 0.02667rem solid #f2f2f2;
  }

  ::v-deep .van-field__value {
    margin-left: 15.5px;
  }

  ::v-deep .van-field__control {
    color: #808C9B;
  }

  .describe-button-around {
    position: absolute;
    width: 100%;
    bottom: 0;
    align-items: center;
    justify-content: center;

    .describe-button {
      width: 100%;
      height: 44px;
      background-color: #005BAC;
      border: none;
      font-size: 15px;
      color: #ffffff;
    }
  }

  .add-equipment {
    display: flex;
    width: 345px;
    justify-content: flex-end;
  }

  .back-ground {
    width: 100%;
    height: 100%;
    z-index: -999;
    position: absolute;
  }

  .user-compile {
    padding: 0 13px;
    margin-top: 13.5px;
    width: 345px;
    background-color: #FFFFFF;

    ::v-deep .dr__maintenance .base-info .info-item .info_value p {
      font-size: 15.4px;
      color: #333333;
    }

    .compile-info {
      .compile-icon {
        width: 17px;
        height: 15px;
      }
    }

    .head-portrait {
      display: flex;
      align-items: center;

      .maintenance-width {
        width: 345px;
      }
    }

    .head-portrait-img {
      height: 31px;
      width: 31px;
      margin-right: 20px;
    }
  }

  .equipment-info {
    padding: 13.5px;
    margin-top: 13.5px;
    width: 345px;
    background-color: #fff;

    .none-margin {
      border-bottom: none;
    }

    .compile-icon {
      width: 17px;
      height: 17px;
    }
  }
}
</style>
